export default "__VITE_ASSET__286b6ea3__"